import getOcTheme from '../../theme/services/getOcTheme';

const { palette } = getOcTheme();

export default {
  '& .oc-video': {
    position: 'relative',

    '&__iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none',
    },
  },
  '& .oc-video, & video': {
    background: palette.background.secondary,
    display: 'block',
    width: '100%',
    margin: '15px auto',
    aspectRatio: 16 / 9,
  },
  '& .oc-video video': {
    margin: 0,
  },
};
